import type { DefaultAttributeValue } from '@source-components-react/types';
import {
  DEFAULT_DIVIDER_STYLE,
  DEFAULT_DIVIDER_THICKNESS,
  DIVIDER_STYLE_ATTRIBUTE,
  DIVIDER_THICKNESS_ATTRIBUTE,
} from './divider-attributes';

/**
 * Seeds the divider's own two settings so the drawer opens on the values a
 * fresh divider is already drawn with, rather than on two empty pickers.
 *
 * Seeding them is safe here in a way it would not be for `r-button`: these
 * names are the divider's own, so nothing in Column Styles writes to them and
 * a seeded value can never shadow a style the author set.
 */
export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: DIVIDER_STYLE_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_DIVIDER_STYLE,
    },
  },
  {
    name: DIVIDER_THICKNESS_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_DIVIDER_THICKNESS,
    },
  },
];
